import { TestResponseItemListCombinedProps } from './types';

const usePresenter = (props: TestResponseItemListCombinedProps): TestResponseItemListCombinedProps => {
  return props;
};

export default usePresenter;
